import React, {Component} from "react";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import {PopUpContext} from "../../contexts/popUpContext";
import Form from "../common/Form";

class StudentResultUpdateForm extends Form {
    static contextType = PopUpContext;

    state = { response: {}};

    schema = { };

    doSubmit = async (e) => {

        const {
            togglePopUp,
            popUp: {subjectId, classId, results, callback},
        } = this.context;

        const url = `results/classes/${classId}/${subjectId}`

        for(let res of results){
            this.cleanObject(res);
        }

        try {
            await db
                .edit(url, results)
                .then((response) => {
                    this.state.response = response;
                    togglePopUp({form: "toast", message: "ویرایش گردید"});
                })
                .catch((err) => {
                    togglePopUp({
                        form: "toast",
                        message: err.toString(),
                        type: "warning",
                    });
                });
        } catch ({response}) {
            if (response && response.status === 400) {
                const errors = {...this.state.error};

                this.setState({errors});
            }
        } finally {
            if (callback) callback(this.state.response)
        }
    };

    componentWillUnmount = async () => {
        const {  popUp } = this.context;
        if (popUp.callback) popUp.callback(this.state.response)
    }

    render() {
        const {togglePopUp, popUp} = this.context;

        return (
            <div className="form-container">
                <form className="form crud" onSubmit={this.handleSubmit}>
                    <div className="head">
                        <p>{lbl.AreYouSure}</p>
                    </div>
                    <div className="form-paragraphs">
                        <p>{lbl.ConfirmStudentResultUpdate}</p>
                    </div>
                    <div className="form-buttons">
                        {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
                    </div>
                </form>
            </div>
        );
    }
}

export default StudentResultUpdateForm;
